import initialState from '../../initialState';
import { NavigationBarActions } from '../../constants';

const reducer = (state = initialState.NavigationBar, action = {}) => {
  switch (action.type) {
    case NavigationBarActions.UPDATE_THEME:
      return { ...state, darkToggle: action.payload };
    default:
      return state;
  }
};
export default reducer;
